import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';
import { getBaseHomePageData, BaseHomePageData } from '@api/homePage';

export const useBaseHomePageData = () => {
  const { data, isLoading } = useQuery<BaseHomePageData>({
    queryKey: ['baseHomePageData'],
    queryFn: getBaseHomePageData,
  } as UseQueryOptions<BaseHomePageData>);

  return {
    baseHomePageData: data ?? null,
    isLoading,
  };
};
